import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locales/en.json'
import uk from '@/locales/uk.json'
import store from '@/store'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.locale.currentLocale, // use store for default locale
  fallbackLocale: 'en', // set fallback locale
  messages: {
    en,
    uk
  }
})

// Watch for locale changes in the store
store.watch(
  state => state.locale.currentLocale,
  newLocale => {
    i18n.locale = newLocale
  }
)

export default i18n
